import { useAtom } from "jotai";
import React, { useEffect, useState } from "react";
// import { useMediaQuery } from "react-responsive";
import { useParams, useSearchParams } from "react-router-dom";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import PAppointmentCard from "../components/PAppointmentCard";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useItemsFilter } from "../../_helper/actions/app/items";
import CuModal from "../../common_component/component/CuModal";
import Rx from "../layouts/Rx";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import { useMediaQuery } from "react-responsive";
import Invoice from "../components/Invoice";
import InvoiceComponent from "../components/InvoiceComponent";
import { toast } from "react-toastify";

const Appointments = () => {
  const sm = !useMediaQuery({ query: "(min-width:768px)" });
  const [consultationId, setConsultationId] = useState("");
  const [rxOpen, setRxOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const option = searchParams.get("option");
  const allClinic = searchParams.get("all_clinic");
  const userId = searchParams.get("userId");
  //   const isSmallScreen = useMediaQuery({ maxWidth: 768 });
  const [clinic] = useAtom(clinicAtom);
  const [appoinmentType, setAppointmentType] = useState("upcoming");
  const [showInvoice, setShowInvoice] = useState(false);
  const [slotId, setSlotId] = useState("");

  const appointmentTypeParams = {
    upcoming: "upcoming=True",
    pending: "pending=True",
    completed: "completed=True",
  };

  const filter = `?action=getSlots&backend=True&clinic_id=${clinic?.id}&patient_id=${userId}&clinic=True&${appointmentTypeParams[appoinmentType]}`;

  const { data, isLoading } = useItemsFilter(
    ApiEndPoint.BOOKING,
    filter,
    clinic && userId ? true : false
  );

  // //("id and data", id, data);
  const handleClickRx = (id, data) => {
    // //(data);
    setConsultationId(id);
    setRxOpen(true);
  };

  const { data: consultationData, isLoading: consultationLoading } =
    useItemsFilter(
      ApiEndPoint.QP_CM_CONSULTATION_DATA,
      `?action=getConsultationData&frontend=True&clinic_id=${clinic?.id}&id=${consultationId}`,
      clinic?.id && consultationId ? true : false
    );

  const {
    data: billData,
    isLoading: billLoading,
    isSuccess,
  } = useItemsFilter(
    ApiEndPoint.BOOKING,
    `?action=getSlots&backend=True&completed=True&id=${slotId}&invoice=True&clinic_id=${clinic?.id}`,
    clinic && slotId ? true : false
  );

  // const handleShowInvoice = (id) => {
  //   if (id) {
  //     setSlotId(id);
  //     if (isSuccess) {
  //       //("----enter isfetched");
  //       if (billData && billData[0]?.invoice_id.length > 0) {
  //         //("what is the -------");
  //         setShowInvoice(true);
  //       } else {
  //         toast.error("Invoice not available");
  //         setSlotId("");
  //       }
  //     }
  //   }
  // };

  const handleShowInvoice = (id) => {
    if (id) {
      setSlotId(id);
    }
  };

  useEffect(() => {
    if (billData && billData[0]?.invoice_id.length > 0) {
      setShowInvoice(true);
    } else if (slotId && !billLoading) {
      toast.error("Invoice not available");
      setSlotId("");
    }
  }, [billData, slotId, billLoading]);

  const handleCloseInvoice = () => {
    setSlotId("");
    setShowInvoice(false);
  };

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-4 p-4 border border-gray-200 ">
        {/* Type Filter */}
        <div className="flex items-center gap-2">
          <span className="font-bold text-gray-700">Type:</span>
          <select
            className="h-9 w-32 border border-gray-300 px-2 rounded-md bg-gray-50 text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
            onChange={(e) => setAppointmentType(e.target.value)}
          >
            <option value="upcoming">Upcoming</option>
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
          </select>
        </div>

        {/* Doctor Filter */}
        <div className="flex items-center gap-2">
          <label className="text-gray-700 font-bold">Doctor:</label>
          <input
            type="checkbox"
            className="w-5 h-5 accent-blue-500 cursor-pointer"
          />
        </div>
      </div>

      {isLoading ? (
        <CuScreenLoader />
      ) : (
        <div className="mt-3">
          {data && data?.length > 0 ? (
            <>
              {data?.map((item, i) => {
                // if (
                //   new Date(item.start_time) > new Date() &&
                //   item.status === "booked"
                // ) {
                return (
                  <PAppointmentCard
                    data={item}
                    key={i}
                    isLoading={
                      consultationLoading &&
                      consultationId === item?.consultation_data[0]?.id
                    }
                    onclickRx={() =>
                      handleClickRx(item?.consultation_data[0]?.id, item)
                    }
                    showRecipt={() => handleShowInvoice(item?.id)}
                    billLoading={billLoading && item?.id === slotId}
                    appoinmentType={appoinmentType}
                  />
                );
                // }
              })}
            </>
          ) : (
            <div className="flex items-center justify-center min-h-[50vh] ">
              <div className="text-center  p-6  max-w-md">
                <h1 className="text-xl font-bold text-gray-800 mb-2">
                  No Slots Available
                </h1>
                <p className="text-gray-600">
                  Please check back later or try selecting a different
                  appointment type.
                </p>
              </div>
            </div>
          )}
          {rxOpen && consultationData && (
            <CuModal closeModal={() => setRxOpen(false)}>
              <Rx
                consultationId={consultationId}
                setRxOpen={setRxOpen}
                consultationData={consultationData}
                consultationLoading={consultationLoading}
              />
            </CuModal>
          )}
        </div>
      )}

      {showInvoice &&
        !billLoading &&
        slotId &&
        (sm ? (
          <Invoice
            closeInvoice={handleCloseInvoice}
            data={billData[0]?.invoice_id[0]}
          />
        ) : (
          <CuModal closeModal={handleCloseInvoice}>
            <div className="w-[667px]">
              <InvoiceComponent
                closeInvoice={handleCloseInvoice}
                data={billData[0]?.invoice_id[0]}
              />
            </div>
          </CuModal>
        ))}
    </>
  );
};

export default Appointments;
